/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesGamesListResponse interface.
 */
export function instanceOfFxIdWebFeaturesGamesListResponse(value) {
    if (!('AvailableGames' in value) || value['AvailableGames'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesGamesListResponseFromJSON(json) {
    return FxIdWebFeaturesGamesListResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AvailableGames': json['AvailableGames'],
    };
}
export function FxIdWebFeaturesGamesListResponseToJSON(json) {
    return FxIdWebFeaturesGamesListResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesListResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AvailableGames': value['AvailableGames'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesGamesListResponse.js.map